import React from "react";
import { Box, Button, Typography, Container, useTheme, useMediaQuery } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

/**
 * Full-screen duplicate image error component
 * Shows when duplicate image is detected (like image 4)
 */
const DuplicateImageError = ({ onReupload }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <div style={{ 
      width: "100%", 
      height: "100vh", 
      display: "flex", 
      justifyContent: "center", 
      alignItems: "center",
      position: "fixed",
      top: 0,
      left: 0,
      zIndex: 9999,
      backgroundColor: "rgba(249, 252, 255, 1)"
    }}>
      <Container sx={{ 
        display: "flex", 
        flexDirection: "column", 
        alignItems: "center", 
        justifyContent: "center",
        textAlign: "center",
        maxWidth: { xs: "90%", sm: "500px", md: "480px" },
        padding: { xs: "16px", sm: "20px" },
        width: "100%"
      }}>
        {/* Error Icon and Message */}
        <Box
          sx={{
            background: "#FFF9E6",
            border: "1px solid #FFE082",
            borderRadius: "8px",
            padding: { xs: "16px", sm: "20px" },
            marginBottom: { xs: "16px", sm: "20px" },
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: { xs: "8px", sm: "10px" },
            width: "100%"
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: { xs: "10px", sm: "12px" }, width: "100%" }}>
            <Box sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
              <img src="/assests/images/Duplicate-icon.svg" alt="" style={{ width: "32px", height: "32px" }} />
            </Box>
            <Typography 
              fontSize={{ xs: "14px", sm: "16px" }}
              fontWeight={500} 
              sx={{ color: "#F57C00", flex: 1, wordBreak: "break-word" }}
            >
              Duplicate Image Detected
            </Typography>
          </Box>
          <Typography
            fontSize={{ xs: "13px", sm: "14px" }}
            fontWeight={400}
            sx={{ color: "#5D5D5D", lineHeight: 1.5, pl: { xs: 0, sm: "44px" } }}
          >
            This image has already been uploaded to our database for a different patient. Please upload the correct image for this patient.
          </Typography>
        </Box>

        {/* Re-upload Button */}
        <Button
          variant="contained"
          onClick={onReupload}
          endIcon={<RefreshIcon />}
          sx={{
            background: 'linear-gradient(270deg, #051572 7.32%, #0820B4 92.68%)',
            borderRadius: "8px",
            color: "#FFF",
            textTransform: "none",
            fontSize: { xs: "14px", sm: "16px" },
            fontWeight: 500,
            padding: { xs: "8px 12px", sm: "8px 16px" },
            width: "fit-content",
            minWidth: "unset",
            maxWidth: "fit-content",
            '&:hover': {
              background: 'linear-gradient(270deg, #041461 7.32%, #071A9F 92.68%)',
            }
          }}
        >
          Re-upload
        </Button>
      </Container>
    </div>
  );
};

export default DuplicateImageError;

